import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function HalfThousandIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3833" data-mp="2jbi1rn71eand">
      <div className="relative w-full h-full bg-gradient-to-b from-indigo-300 via-violet-400 to-purple-500 overflow-hidden" data-id="element-3834" data-mp="29dkfh58qmnxe">
        {/* Background: Launch sky + stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3835" data-mp="24er87uk1nt5o">
          <circle cx="40" cy="40" r="2" fill="white" data-id="element-3836" data-mp="2ltabkbeuadv" />
          <circle cx="160" cy="30" r="1.5" fill="white" data-id="element-3837" data-mp="3ur6pigs47dp8" />
          <circle cx="120" cy="60" r="2" fill="white" data-id="element-3838" data-mp="3urorzv5deo5l" />
          <circle cx="30" cy="90" r="1.5" fill="white" data-id="element-3839" data-mp="2lpsjb0vywvwa" />
          <circle cx="175" cy="80" r="2" fill="white" data-id="element-3840" data-mp="2ls4w6zmvcg2h" />
          {/* Rocket trail */}
          <path d="M100 200 Q95 150 100 110 Q105 150 100 200 Z" fill="#FCD34D" opacity="0.5" data-id="element-3841" data-mp="2qqg9xlgabapz" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[6%]" data-id="element-3842" data-mp="2grqqho8qpi7m">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3843" data-mp="34hl2k3l8j2qt">
            <DjaySpecimen look={{
            variant,
            accessory: 'starWand'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3844" data-mp="39g60fwd0lac3" />
          </div>
        </div>

        {/* Foreground: "500" + sparks */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3845" data-mp="3s75w1gf0liec">
            <text x="100" y="44" textAnchor="middle" fontFamily="sans-serif" fontSize="24" fontWeight="900" fill="#FDE047" stroke="#7C3AED" strokeWidth="1" data-id="element-3846" data-mp="1wg8qhxmx8em">
              500
            </text>
            <path d="M40 120 L42 128 L50 130 L42 132 L40 140 L38 132 L30 130 L38 128 Z" fill="#FDE047" data-id="element-3847" data-mp="3j53977icy7fv" />
            <path d="M165 130 L167 137 L174 139 L167 141 L165 148 L163 141 L156 139 L163 137 Z" fill="#A78BFA" data-id="element-3848" data-mp="3aa5fhy7dyqnh" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}